import { render, staticRenderFns } from "./SectionSelectionCheckbox.vue?vue&type=template&id=b3547812&scoped=true&lang=html&"
import script from "./SectionSelectionCheckbox.vue?vue&type=script&lang=js&"
export * from "./SectionSelectionCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3547812",
  null
  
)

export default component.exports